export const GALogin = (userExist, source, userId) => {
  const dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: userExist ? "login" : "sign_up",
    method: "phone",
    auth_source: source,
    user_id: userId,
  });
};
